/* eslint-disable comma-dangle */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import VueQriously from 'vue-qriously';
import router from './router/route';
import VueI18n from 'vue-i18n';

Vue.use(VueQriously);
Vue.use(ElementUI);
Vue.use(VueI18n);
/* eslint-disable no-new */
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: require('./common/i18n/app-zh.json'),
    en: require('./common/i18n/app-en.json'),
  },
});
new Vue({
  el: '#app',
  components: {
    App,
  },
  i18n,
  router,
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js